module.exports = __webpack_public_path__ + "assets/img/label-classify-2.cbf0c295.png";